import _ from 'lodash';
import 'edge/quoteandbind/common/models/Submission';
import 'edge/quoteandbind/common/models/Person';
import Vehicle from 'customerEdge/quoteandbind/puw/models/Vehicle';

let nextId;

const PUWCoverables = function (data, submission) {
    if (data && _.isObject(data)) {

        this.vehicles = _.map(data.vehicles, _.bind((v) => {
            return new Vehicle(v);
        }, this));
    } else {
        this.vehicles = [];
    }
};

PUWCoverables.prototype.createVehicle = function () {
    const v = new Vehicle({
        tempId: nextId()
    });
    this.vehicles.push(v);
    return v;
};

PUWCoverables.prototype.removeVehicle = function (vehicle) {
    const idx = _.indexOf(this.vehicles, vehicle);
    if (idx >= 0) {
        this.vehicles.splice(idx, 1);
    }
};

const PUWSubmissionDataExtension = function (submission) {
    nextId = submission.nextId;

    const puwData = submission.lobData.puw_PSA;
    if (puwData) {
        this.preQualQuestionSets = puwData.preQualQuestionSets || [];
        this.offerings = puwData.offerings || [];
        this.coverables = new PUWCoverables(puwData.coverables, submission);
    }
};

export default PUWSubmissionDataExtension;
